var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28619_303235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9318 0H1.56818C0.564028 0 -0.25 1.01753 -0.25 2.27273V22.7273C-0.25 23.9825 0.564028 25 1.56818 25H37.9318C38.936 25 39.75 23.9825 39.75 22.7273V2.27273C39.75 1.01753 38.936 0 37.9318 0Z",
    fill: "#8D8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4773 4.54546H3.38637V11.3636H12.4773V4.54546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84091 18.1818H3.38637V20.4545H8.84091V18.1818Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9318 18.1818H12.4773V20.4545H17.9318V18.1818Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0227 18.1818H21.5682V20.4545H27.0227V18.1818Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1136 18.1818H30.6591V20.4545H36.1136V18.1818Z",
    fill: "#4B4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28619_303235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 25,
    fill: "white",
    transform: "translate(-0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric);
export default __webpack_public_path__ + "static/media/generic.9b96c613a3eacf83f336e6a0b46b758a.svg";
export { ForwardRef as ReactComponent };